<template>
  <li
    class="md-list-item"
    :class="{ 'sub-nav-item': subItem }"
  >
    <router-link
      class="md-list-item-router md-list-item-container md-button-clean"
      :to="link.path"
      @click="hideSidebar"
    >
      <div class="md-list-item-content md-ripple">
        <md-icon>{{ link.icon }}</md-icon>
        <p>{{ link.label }}</p>
      </div>
    </router-link>
  </li>
</template>
<script>

export default {
  inject: {
    autoClose: {
      default: true
    }
  },
  props: {
    link: {
      type: Object,
      default() {
        return {
          path: "/",
          icon: "",
          label: ""
        };
      },
      path: {type: String, default: "/"},
      icon: {type: String, default: ""},
      label: {type: String, default: ""}
    },
    subItem: Boolean,
    tag: {
      type: String,
      default: "router-link"
    }
  },
  methods: {
    hideSidebar() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
<style scoped>
  .sub-nav-item {
    margin: 8px 0 0 20px;
  }
</style>
